import React, { useEffect, Fragment } from "react";

export default function Controls(props) {
  // useEffect(() => {
  //   console.log("controls mounted!");
  // }, []);

  return <Fragment>{props.children}</Fragment>;
}
